import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default function Testimonios() {
  const testimonios = [
    {
      texto: '“Ya llegamos a Mendoza Belén, mil gracias por todo”',
      autor: 'Maríano'
    },
    {
      texto: '“Gracias Belu, espero que sigas así y te vaya de 1000000”',
      autor: 'Karim'
    },
    {
      texto: '“Hola Belen, ya estamos otra vez en casa. La verdad todo maravilloso, una excelente atención y el complejo una maravilla. Gracias por todo”',
      autor: ''
    },
    {
    texto: '“Hola Belén, realmente muy bien. La posada muy bien, linda con un buen servicio, muy recomendable. Gracias!”',
    autor: 'Daniel'
    },
    {
        texto: '“La pasamos hermoso en nuestro viaje. Muchísimas gracias como siempre por todo”',
        autor: 'Sebastián'
    },
    {
        texto: '“Bellísima, ya estamos en Mendoza. Todo tan excelente!! Un sueño hecho realidad. Gracias”',
        autor: 'Florencia'
    },
    {
        texto: '“Belu gracias por todooo”',
        autor: 'Antonio'
    },
    {
        texto: '“La mejor, te saca y te pone en otro país en minutos. Una GENIA. Re aconsejable, muy honesta”',
        autor: 'Beatriz'
    },
    {
        texto: '“Hola Belén, hermoso el hotel, la atención, todo! Nada que decir, muchas gracias por todo Belén”',
        autor: 'Flavia'
    },
    {
        texto: '“Primero agradecerte, salió todo divinooooooooo, te he mandado varios clientes”',
        autor: 'Magalí'
    },
    {
        texto: '“Hermosoooo, gracias mi vida”',
        autor: 'Marité'
    },
    {
        texto: '“Gracias por estar siempre ahí, te quiero”',
        autor: 'Laura'
    },
     {
        texto: '“Está hermoso todo, la verdad que super recomendable Belu”',
        autor: 'Antonella'
    },
  ];

  return (
    <section id="testimonios" className="bg-[#B49A56] py-16 px-4 w-full">
      <div className="max-w-screen-md mx-auto text-center">
        <h2 className="text-3xl font-bold text-[#FFFFFF] mb-8">LO QUE DICEN NUESTROS VIAJEROS</h2>

        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 6000, disableOnInteraction: false }}
          loop
          spaceBetween={30}
          slidesPerView={1}
        >
          {testimonios.map((t, i) => (
            <SwiperSlide key={i}>
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition h-full">
                <p className="text-gray-700 italic mb-4">{t.texto}</p>
                <div className="font-bold text-[#B49A56]">{t.autor}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}